import { useEffect, useState } from 'react'

import { useTheme } from '@chakra-ui/react'
import { CheckIcon, RightChevronIcon } from '@verbit-ai/icons-library'
import { Drawer } from '@verbit-ai/verbit-ui-library'

import { useSetThemeField } from 'src/contexts/ThemeContext'
import { analyticsService } from 'src/services/AnalyticsService'
import { THEME_TYPES } from 'src/themes/types'
import { THEMES_PRESENTATION, ThemeToggleProps } from 'src/components/ThemeToggle/types'
import { ThemeButton, ThemeOptionItem, ThemeOptionList } from 'src/components/ThemeToggle/styles'
import { ThemeTextCustomization } from 'src/components/ThemeToggle/ThemeTextCustomization'
import { useResponsiveContainer } from 'src/contexts/ResponsiveContainerContext'

import * as S from './styles'

type ThemeToggleMobileStage = 'themesList' | 'textCustomization'

const componentTitles: Record<ThemeToggleMobileStage, string> = {
    themesList: 'Select a theme',
    textCustomization: 'Custom text',
}

export const ThemeToggleMobile = (props: ThemeToggleProps) => {
    const { isOpen, onClose } = props
    const {
        palette: {
            themeToggle: { iconColor },
        },
        themeType: activeThemeType,
    } = useTheme()
    const setThemeField = useSetThemeField()
    const [stage, setStage] = useState<ThemeToggleMobileStage>('themesList')
    const { containerRef } = useResponsiveContainer()

    useEffect(() => {
        if (isOpen) {
            analyticsService.track('Accessibility panel opened', {})
        }
    }, [isOpen])

    const templatesByStage: Record<ThemeToggleMobileStage, React.JSX.Element> = {
        themesList: (
            <>
                <ThemeOptionList role="list">
                    {THEME_TYPES.filter((themeType) => THEMES_PRESENTATION[themeType].isVisible).map((themeType) => {
                        const isSelected = themeType === activeThemeType

                        return (
                            <ThemeOptionItem key={themeType}>
                                <ThemeButton aria-pressed={isSelected} onClick={() => setThemeField('themeType', themeType)}>
                                    {THEMES_PRESENTATION[themeType].name}
                                    {isSelected && <CheckIcon color={iconColor} aria-hidden />}
                                </ThemeButton>
                            </ThemeOptionItem>
                        )
                    })}
                </ThemeOptionList>
                <ThemeButton onClick={() => setStage('textCustomization')}>
                    Custom text <RightChevronIcon color={iconColor} />
                </ThemeButton>
            </>
        ),
        textCustomization: <ThemeTextCustomization />,
    }

    const onOverlayClose = () => {
        onClose()
        setStage('themesList')
    }

    return (
        <Drawer isOpen={isOpen} onClose={onOverlayClose} placement="bottom" autoFocus={false} portalProps={{ containerRef }}>
            <S.ThemeToggleContainer>
                <S.ThemeSelectionTitle>{componentTitles[stage]}</S.ThemeSelectionTitle>
                {templatesByStage[stage]}
            </S.ThemeToggleContainer>
        </Drawer>
    )
}
